module.exports = __webpack_public_path__ + "static/media/user-circle-regular.d7be23e9.svg";